// extracted by mini-css-extract-plugin
export default {"main-footer-container__useful-links":"MainFooterUsefulLink_main-footer-container__useful-links__UsxRM"};